import { METHOD } from 'services/method'

export const API_FLASH_SALE = {
    LIST: {
        api: '/v1/dashboard-admin/flash-sale/list',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/flash-sale',
        method: METHOD.DELETE,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/flash-sale/products',
        method: METHOD.GET,
    },
    URL_FLASH_SALE_IMAGES: {
        api: '/v1/dashboard-admin/flash-sale/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/flash-sale',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/flash-sale',
        method: METHOD.PUT,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/flash-sale/detail',
        method: METHOD.GET,
    },
}
